// Ajax solr
$(function () {
	'use strict';
	const RESULTS_SELECTOR = '.js-results';
	const PLUGIN_SELECTOR = '.tx_solr';
	const LOADING_CLASS = 'is-loading';

	var ajaxifyUrl = function (url, type, record) {
		var glue = url.indexOf('?') === -1 ? '?' : '&';
		return url + glue + 'type=' + type + '&record=' + record;
	};

	var search = function (url, data, $target, pushHistory = true) {
		$target.addClass(LOADING_CLASS);
		$('html').removeClass('facets-popup-open');

		var onBeforeSend = pushHistory ? function (jqXHR, settings) {
			try {
				var pushUrl = new URL(settings.url, window.location.origin);
				var params = new URLSearchParams(pushUrl.search);
				params.delete('type');
				params.delete('record');
				pushUrl.search = params.toString();
				history.pushState({url: url, data: data}, null, pushUrl.toString());
			} catch (e) {
				// Ignore
			}
		} : $.noop;

		$.ajax({
			url: url,
			data: data,
			beforeSend: onBeforeSend,
			success: function (response) {
				var $response = $(response);
				$target.removeClass(LOADING_CLASS);
				$target.find('.js-hidden-fields-input').html(
					$response.find('.js-hidden-fields-input').html()
				);
				$target.find('.js-facets').html(
					$response.find('.js-facets').html()
				);
				$target.find('.js-results').html(
					($response.find('.js-results').html() ? $response.find('.js-results').html() : "")
				);
				$target.find('.js-results-counter').html(
					$response.find('.js-results-counter').html()
				);
				$target.find('.js-hidden-fields').html(
					$response.find('.js-hidden-fields').html()
				);
			}
		});
	};

	$(PLUGIN_SELECTOR).on('submit', '.js-personsearch form', function (event) {
		event.preventDefault();
		var $form = $(this);
		var $target = $form.closest(PLUGIN_SELECTOR);
		var type = $form.closest('[data-type]').data('type');
		var record = $form.closest('[data-record]').data('record');
		var data = $form.serializeArray();
		data.push({name: 'type', value: type});
		data.push({name: 'record', value: record});
		search($form.attr('action'), data, $target);
	});


	$(PLUGIN_SELECTOR).on('click change', '.js-facets [data-href]', function (event) {
		event.preventDefault();
		$('html').removeClass('facets-popup-open');
		var $el = $(this);
		var $target = $el.closest(PLUGIN_SELECTOR);
		var type = $el.closest('[data-type]').data('type');
		var record = $el.closest('[data-record]').data('record');
		var data = [];
		data.push({name: 'type', value: type});
		data.push({name: 'record', value: record});
		search($el.data('href'), data, $target);
	});

	window.addEventListener('popstate', function(e) {
		if (e.state) {
			search(e.state.url, e.state.data, $(PLUGIN_SELECTOR), false);
			$.each(e.state.data, function (i, value){
				$('[name="'+value.name+'"]').val(value.value);
			});
		}
	});
});